export class FiltroDemonstrativoImpostoRenda {

    idConsumidor: number;
    anoCalendario: number;
      
    constructor(idConsumidor: number, anoCalendario : number) {
        this.idConsumidor = idConsumidor;
        this.anoCalendario = anoCalendario;
    }
  }
  


// WEBPACK FOOTER //
// ./src/app/shared/filter/filtro-demonstrativo-imposto-renda.ts